<template>
  <div class="content">
    <!-- 导航栏部分 -->
    <div class="nav">
      <van-nav-bar
        title="住院预交金充值"
        left-arrow
        @click-left="onClickLeft"
      />
    </div>
    <div class="amount">
      <div class="amountBtn">
        <div
          :class="{ border: border == index }"
          class="amount_box"
          v-for="(item, index) in amountList"
          :key="index"
          @click="selected(index, item)"
        >
          {{ item.fee }} 元
        </div>
      </div>
      <div class="input">
        <van-cell-group>
          <van-field
            v-model="amount"
            label="其他金额"
            placeholder="请输入金额 ￥"
          />
        </van-cell-group>
      </div>
    </div>
    <div class="payBtn" @click="gopay()">确 认 充 值</div>
  </div>
</template>


<script>
import Nav from "../ElectronicHealthCard/components/nav.vue";
export default {
  data() {
    return {
      //wx支付需要参数
      appId: "",
      timeStamp: "",
      nonceStr: "",
      package: "",
      signType: "",
      paySign: "",
      out_trade_no: "",
      border: -1,
      amount: "",
      amountList: [
        { id: 2, fee: "100" },
        {
          id: 3,
          fee: "200",
        },
        {
          id: 4,
          fee: "300",
        },
        {
          id: 5,
          fee: "400",
        },
        {
          id: 6,
          fee: "500",
        },
        {
          id: 7,
          fee: "600",
        },
        {
          id: 8,
          fee: "700",
        },
        {
          id: 9,
          fee: "800",
        },
        {
          id: 10,
          fee: "900",
        },
        {
          id: 11,
          fee: "1000",
        },
      ],
      payWay: "",
      totFee: "",
      clientId: "",
      InPatientId: "",
      clientName: "",
      deptId: "",
    };
  },
  mounted() {
    this.clientId = this.$route.query.clientId;
    this.InPatientId = this.$route.query.InPatientId;
    this.clientName = this.$route.query.clientName;
    this.deptId = this.$route.query.deptId;
    this.getPayWay();
  },
  methods: {
    async getPayWay() {
      try {
        this.$showLoad();
        let url = "/hospitalconf/index/getPayType";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            this.$hideLoad();
            this.payWay = data.data.objType[0].paykey;
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    onBridgeReady(appId, timeStamp, nonceStr, pacKage, signType, paySign) {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: appId, //公众号名称，由商户传入
          timeStamp: timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: nonceStr, //随机串
          package: pacKage,
          signType: signType, //微信签名方式：
          paySign: paySign, //微信签名
        },
        (res) => {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            this.$showLoad("支付确认中...");
            this.timer = setTimeout(() => {
              this.$hideLoad();
              this.$router.push({
                path: "/payRank",
                query: {
                  clientId: this.clientId,
                  InPatientId: this.InPatientId,
                  clientName: this.clientName,
                  deptId: this.deptId,
                },
              });
            }, 3000);
          }
        }
      );
    },
    onClickLeft() {
      this.$router.push({
        path: "/payRank",
        query: {
          clientId: this.clientId,
          InPatientId: this.InPatientId,
          clientName: this.clientName,
          deptId: this.deptId,
        },
      });
    },
    selected(index, item) {
      console.log(item);
      this.border = index;
      this.totFee = item.fee;
      this.amount = "";
    },
    async gopay() {
      if (!this.totFee) {
      }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   
      let ftotFee = this.amount || this.totFee;
      console.log(ftotFee);
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/outpatientfee/prepayforhospitalization";
        let data = {
          inPatientId: this.InPatientId,
          deptId: this.deptId,
          clientId: this.clientId,
          payWay: this.payWay,
          clientName: this.clientName,
          totFee: ftotFee,
          mode: "prepay", //处方缴费
          body: "住院预交金",
          detail: "住院预交金",
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            this.$hideLoad();
            if(data.return_code=="FAIL"){
              this.$toast.fail(data.return_msg)
              return
            }
            if(data.status=="400"){
               this.$toast.fail("未输入金额或网络异常")
               return
            }
            this.appId = data.data.result_uninorder.appId;
            this.timeStamp = data.data.result_uninorder.timeStamp;
            this.nonceStr = data.data.result_uninorder.nonceStr;
            this.pacKage = data.data.result_uninorder.package;
            this.signType = data.data.result_uninorder.signType;
            this.paySign = data.data.result_uninorder.paySign;
            // this.out_trade_no = data.data.out_trade_no;
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady(
                    this.appId,
                    this.timeStamp,
                    this.nonceStr,
                    this.pacKage,
                    this.signType,
                    this.paySign
                  ),
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady(
                    this.appId,
                    this.timeStamp,
                    this.nonceStr,
                    this.pacKage,
                    this.signType,
                    this.paySign
                  )
                );
                document.attachEvent(
                  "onWeixinJSBridgeReady",
                  this.onBridgeReady(
                    this.appId,
                    this.timeStamp,
                    this.nonceStr,
                    this.pacKage,
                    this.signType,
                    this.paySign
                  )
                );
              }
            } else {
              this.onBridgeReady(
                this.appId,
                this.timeStamp,
                this.nonceStr,
                this.pacKage,
                this.signType,
                this.paySign
              );
            }
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.isLoad = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100vh;
  background-color: rgb(247, 248, 250);
  .amount {
    width: 90%;
    background-color: rgb(247, 248, 250);
    margin: 0 auto;
    height: 75vh;
    .amountBtn {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      height: 70%;
      overflow-y: scroll;
      margin-top: 15px;
      background-color: #fff;
      .amount_box {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        width: 40%;
        height: 70px;
        color: #5b8df6;
        background-color: #fff;
        border: 1px solid #5b8df6;
        margin: 5px auto;
      }

      .border {
        background-color: #5b8df6;
        color: #fff;
      }
    }

    .input {
      margin-top: 25px;
    }
  }
  .payBtn {
    height: 10vh;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    height: 50px;
    border-radius: 15px;
    width: 90%;
    margin: 0 auto;
    background-color: #5b8df6;
    margin-bottom: 1px;
  }
}
</style>